import { createContext, ReactNode, useCallback, useMemo, useState } from 'react';
import ErrorDialog, { ErrorDialogProps } from './ErrorDialog';

type DialogContextType = {
  error: (config: ErrorDialogProps) => void;
};

export const DialogContext = createContext<DialogContextType>({
  error: () => {},
});

const DialogProvider = ({ children }: { children: ReactNode }) => {
  const [errorDialogConfig, setErrorDialogConfig] = useState<ErrorDialogProps | null>(null);

  const error = useCallback((config: ErrorDialogProps) => {
    setErrorDialogConfig(config);
  }, []);

  const handleClose = useCallback(() => {
    setErrorDialogConfig(null);
  }, []);

  const contextValue = useMemo(() => ({ error }), [error]);

  return (
    <DialogContext.Provider value={contextValue}>
      {errorDialogConfig && <ErrorDialog {...errorDialogConfig} onClose={handleClose} />}
      {children}
    </DialogContext.Provider>
  );
};

export default DialogProvider;
